/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import appReducer from './containers/PageWrapper/modules/reducer';
import usersReducer from './containers/Paradigms/FormFlow/modules/reducers';
import appealsReducer from 'containers/Appeals/modules/reducer';
import inquiriesReducer from 'containers/Inquiries/modules/reducer';
import myRecentActivitiesReducer from 'containers/MyRecentActivities/modules/reducer';
import documentsReducer from 'containers/Documents/modules/reducer';
import prepayClaimsPageReducer from './containers/Claims/PrepayClaimsPage/modules/reducer';
import searchSectionReducer from 'containers/Claims/SearchSection/modules/reducer';
import rulesReducer from 'containers/RuleSpec/Rules/modules/reducer';
import reasonCodesReducer from 'containers/RuleSpec/ReasonCodes/modules/reducer';
import documentReferencesReducer from 'containers/RuleSpec/DocumentReferences/modules/reducer';
import invoicingReducer from 'containers/Invoicing/modules/reducer';
import clientsReducer from 'containers/ClientManagement/Clients/modules/reducer';
import appealResponsesReducer from 'containers/AppealResponses/modules/reducer';
import activityLogReducer from 'containers/ActivityLog/modules/reducer';

/**
 * Creates the main reducer with the dynamically injected ones
 */

export default function createReducer(injectedReducers = {}, history = null) {
  return combineReducers({
    searchSection: searchSectionReducer,
    prepayClaimsPage: prepayClaimsPageReducer,
    router: connectRouter(history),
    app: appReducer,
    users: usersReducer,
    appealsReducer: appealsReducer,
    inquiriesReducer: inquiriesReducer,
    myRecentActivitiesReducer: myRecentActivitiesReducer,
    documentsReducer: documentsReducer,
    invoicingReducer: invoicingReducer,
    rulesReducer: rulesReducer,
    reasonCodesReducer: reasonCodesReducer,
    documentReferencesReducer: documentReferencesReducer,
    clientsReducer: clientsReducer,
    appealResponsesReducer: appealResponsesReducer,
    activityLogReducer: activityLogReducer,
    ...injectedReducers,
  });
}
